<template>
  <div class="Reward">
    <div class="main" style="padding: 60px;">
      <div class="main_item">
        <!-- <p class="main_title">Invite Reward</p> -->
        <el-form label-width="100px">
          <el-form-item label="Invite Reward">
            <el-input-number v-model="invite_reward" :min="0"
                             label="Invite Reward"></el-input-number>
          </el-form-item>
        </el-form>
      </div>

    </div>
    <div>
      <el-button style="margin-top: 20px;margin-left: 60px;width: 200px"
                 type="primary"
                 @click="onSaveAll">Save
      </el-button>
    </div>
  </div>
</template>

<script>
  import {getConfig, saveConfig} from "@/utils/api";

  export default {
    props: {},
    data: () => {
      return {
        daily_info: false,
        time_range: false,
        invite_reward: 0
      }
    },
    methods: {
      update() {
        getConfig('invite_reward').then(res => {
          this.invite_reward = res.invite_reward || 0;
        })
      },
      onSaveAll() {
        saveConfig({
          key: 'invite_reward',
          value: this.invite_reward
        }).then(res => {
          // console.log(res)
          this.$message.success('Saved');
          this.update()
        })
        // let daily_reward = this.daily_info.daily_reward;
        // let clockin_time = {
        //   start_time: this.time_range[0],
        //   end_time: this.time_range[1]
        // };
        // saveDailyInfo({
        //   daily_reward: daily_reward,
        //   clockin_time: clockin_time
        // }).then(res => {
        //   if (res.errcode === 0) {
        //     this.$message.success('Saved');
        //     getDailyInfo().then(res => {
        //       this.daily_info = res.daily_info;
        //       this.time_range = [res.daily_info.clockin_time.start_time, res.daily_info.clockin_time.end_time]
        //     })
        //   } else {
        //     this.$message.error('Error')
        //   }
        // })
      }
    },
    beforeMount() {
      this.update()
    }
  };
</script>


<style lang="scss" scoped>
  // @import "_Reward.scss";
</style>